import { FC } from 'react';

import { Tag, Link } from '@hh.ru/magritte-ui';
import { FolderOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { FoldersInvariants } from 'src/models/resumeFolders';
import { getFolderById, getFolderUrl } from 'src/utils/resumeFolders';

export interface FolderTagsProps {
    foldersIdList: string[];
    foldersInvariants: FoldersInvariants;
}

const Folders: FC<FolderTagsProps> = ({ foldersIdList, foldersInvariants }) => {
    return (
        <>
            {foldersIdList.map((folderId) => {
                const folderById = getFolderById(foldersInvariants, folderId);

                if (!folderById) {
                    return null;
                }

                return (
                    <Link enableVisited={false} Element={SPALink} key={folderId} to={getFolderUrl(folderId)}>
                        <Tag style="neutral" icon={FolderOutlinedSize16}>
                            {folderById.name || ''}
                        </Tag>
                    </Link>
                );
            })}
        </>
    );
};

export default Folders;
